<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-07 11:53:34
-->
<template>
	<div class="mt-12 yx-form-wrap">
		<el-form :inline="true" :model="formData" label-width="96px">
			<el-form-item label="推广时间" v-if="isNotShopType">
				<el-date-picker
					v-model="freeOrderTime"
					type="daterange"
					@change="changeTimed"
					value-format="yyyy-MM-dd"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
				>
				</el-date-picker>
			</el-form-item>
			<!--先掩藏注释-->
			<!-- <el-form-item label="达人昵称" v-if="isNotShopType">
				<el-input v-model="formData['anchor_name']" placeholder="请输入达人昵称"></el-input>
			</el-form-item>
			<el-form-item label="达人招商" v-if="isNotShopType">
				<el-input v-model="formData['nick_name']" placeholder="请输入达人招商"></el-input>
			</el-form-item> -->
			<el-form-item :label="drName" v-if="!isNotShopType">
				<dr-partner-select v-model="formData['user_id']"></dr-partner-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSubmit">筛选</el-button>
				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import { startOfDay, endOfDay, parseISO } from 'date-fns';
import DrPartnerSelect from '@/components/drPartnerSelect';
import { drRoleType } from '@/utils/dataMap';
export default {
	name: 'search',
	props: {
		tabName: {
			type: String,
			default: () => '',
		},
	},
	data() {
		return {
			formData: {},
			freeOrderTime: '',
		};
	},
	computed: {
		isNotShopType() {
			return this.tabName !== '2';
		},
		drName() {
			return drRoleType.name;
		},
	},
	methods: {
		onClear() {
			this.clearData();
			this.onSubmit();
		},
		clearData() {
			this.formData = {};
			this.freeOrderTime = '';
		},
		changeTimed(value) {
			const [start, end] = value || [];
			this.formData.from_time = start ? startOfDay(parseISO(start)).getTime() / 1000 : '';
			this.formData.to_time = end ? parseInt(endOfDay(parseISO(end)).getTime() / 1000) : '';
		},
		onSubmit: throttle(function() {
			this.$emit('onSubmit', this.formData);
		}, 1000),
	},
	components: {
		DrPartnerSelect,
	},
};
</script>
